module.exports = __webpack_public_path__ + "static/DevOps-588132e75cb5536c4eb10819da5af7fb.jpg";